import React from "react";
import { FormattedMessage } from "react-intl";
import Anchor from "@shared/components/Anchor";
import styles from "./styles.css";
const ID = "TermsAndConditions";
function Description() {
    return (React.createElement("section", { id: ID, className: styles.container },
        React.createElement(Anchor, { id: ID, label: React.createElement(FormattedMessage, { id: "TermsAndConditionsTitle" }) }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "TermsAndConditionsStartText" })),
        React.createElement("strong", null,
            "1. ",
            React.createElement(FormattedMessage, { id: "GeneralInformationTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "GeneralInformationText" })),
        React.createElement("strong", null,
            "2. ",
            React.createElement(FormattedMessage, { id: "UserResponsibilitiesTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "UserResponsibilitiesText" })),
        React.createElement("strong", null,
            "3. ",
            React.createElement(FormattedMessage, { id: "IntellectualPropertyTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "IntellectualPropertyText" })),
        React.createElement("strong", null,
            "4. ",
            React.createElement(FormattedMessage, { id: "PrivacyPolicyTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "PrivacyPolicyText" })),
        React.createElement("strong", null,
            "5. ",
            React.createElement(FormattedMessage, { id: "LiabilityTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "LiabilityText" })),
        React.createElement("strong", null,
            "6. ",
            React.createElement(FormattedMessage, { id: "OfflineAccessTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "OfflineAccessText" })),
        React.createElement("strong", null,
            "7. ",
            React.createElement(FormattedMessage, { id: "PaymentsAndSubscriptionsTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "PaymentsAndSubscriptionsText" })),
        React.createElement("strong", null,
            "8. ",
            React.createElement(FormattedMessage, { id: "ThirdPartyLinksTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ThirdPartyLinksText" })),
        React.createElement("strong", null,
            "9. ",
            React.createElement(FormattedMessage, { id: "TerminationTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "TerminationText" })),
        React.createElement("strong", null,
            "10. ",
            React.createElement(FormattedMessage, { id: "ModificationsToTermsTitle" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ModificationsToTermsText" }),
            " – ",
            React.createElement("a", { href: "mailto:mr.oleski1@gmail.com", target: "_blank", rel: "nofollow noopener", className: styles.email }, "mr.oleski1@gmail.com")),
        React.createElement("br", null),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "TermsAndConditionsEndText" }))));
}
;
export default Description;
